export const urlString = ({ canonical, path }) => new URL(path, canonical).toString()

export const setWindowURL = url => (window.location.href = url)
